import styled from 'styled-components/macro';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #f6f6f6;
    height : 130vh;
    @media (max-width: 900px) {
        height: 110vh;
    },
    @media (max-width: 800px) {
        height: 80vh;
    },
    @media (max-width: 700px) {
        height: 50vh;
    },
`;

export const CarouselContainer = styled.div`
    margin-top: 3rem;

    .fa {
        color: #777777;
    }

`;

export const Image = styled.img`
`;